/**
 * Innolek API - Auto-generated barrel file
 * Generated at: 2026-01-02T11:06:27.071Z
 */

export * from './generated-types';
export * from './generated-client';
export * from './generated-hooks';
export { apiClient } from './generated-client';

// Re-export type aliases (manually maintained in type-aliases.ts)
export * from './type-aliases';

// Re-export api with convenience aliases for client methods
import { api as generatedApi } from './generated-client';

/**
 * API client with convenience aliases for commonly used methods
 * These match the expected names in the frontend codebase
 */
export const api = {
  ...generatedApi,
  // Convenience aliases for client methods
  addItemToCart: generatedApi.addItemToCartApiV1CartAddPost,
  getCart: generatedApi.getCartApiV1CartSessionIdGet,
  clearCart: generatedApi.clearCartApiV1CartSessionIdDelete,
  getCartTotal: generatedApi.getCartTotalApiV1CartSessionIdTotalGet,
  updateCartItem: generatedApi.updateCartItemApiV1CartSessionIdItemsItemIdPatch,
  removeCartItem: generatedApi.removeCartItemApiV1CartSessionIdItemsItemIdDelete,
  removeCartItemFromCookie: generatedApi.removeCartItemFromCookieApiV1CartItemsItemIdDelete,
  createChatSession: generatedApi.createChatSessionApiV1ChatSessionsPost,
  chatMessageStandardized: generatedApi.chatMessageStandardizedApiV1ChatSessionsSessionIdMessagePost,
  chatMessage: generatedApi.chatMessageApiV1ChatMessagePost,
  getOrdersBySession: generatedApi.getOrdersBySessionApiV1OrdersBySessionPost,
  updateDelivery: generatedApi.updateDeliveryApiV1OrdersOrderIdDeliveryPut,
  getOrder: generatedApi.getOrderApiV1OrdersOrderIdGet,
  lookupOrder: generatedApi.lookupOrderApiV1OrderLookup_Post,
  getOrderTotal: generatedApi.getOrderTotalApiV1OrderTotal_Get,
  getTrackingInfo: generatedApi.getTrackingInfoApiV1TrackingOrderIdGet,
  getStatusTimeline: generatedApi.getStatusTimelineApiV1TrackingOrderIdTimelineGet,
  updateOrderStatus: generatedApi.updateOrderStatusApiV1TrackingOrderIdStatusPost,
  getTrackingByEmail: generatedApi.getTrackingByEmailApiV1TrackingByEmailEmailGet,
  getTrackingByOrderNumber: generatedApi.getTrackingByOrderNumberApiV1TrackingByOrderNumberOrderNumberGet,
  refreshDeliveryEstimates: generatedApi.refreshDeliveryEstimatesApiV1TrackingOrderIdRefreshEstimatesPost,
  uploadPhoto: generatedApi.uploadPhotoApiV1PhotosPost,
  createFromUrl: generatedApi.createFromUrlApiV1PhotosFromUrlPost,
  getPhoto: generatedApi.getPhotoApiV1PhotosPhotoIdGet,
  deletePhoto: generatedApi.deletePhotoApiV1PhotosPhotoIdDelete,
  getPhotosBySource: generatedApi.getPhotosBySourceApiV1PhotosBySourceSourceTypeSourceIdGet,
  analyzePhoto: generatedApi.analyzePhotoApiV1PhotosPhotoIdAnalyzePost,
  createThumbnail: generatedApi.createThumbnailApiV1PhotosPhotoIdThumbnailPost,
  updateProcessedUrl: generatedApi.updateProcessedUrlApiV1PhotosPhotoIdProcessedUrlPatch,
  createSession: generatedApi.createSessionApiV1GenerationSessionsPost,
  listSessions: generatedApi.listSessionsApiV1GenerationSessionsGet,
  getSession: generatedApi.getSessionApiV1GenerationSessionsSessionIdGet,
  buildPrompt: generatedApi.buildPromptApiV1GenerationSessionsSessionIdBuildPromptPost,
  generateVariants: generatedApi.generateVariantsApiV1GenerationSessionsSessionIdGeneratePost,
  selectVariant: generatedApi.selectVariantApiV1GenerationVariantsVariantIdSelectPost,
  selectStyleAndGenerate: generatedApi.selectStyleAndGenerateApiV1GenerationSessionsSessionIdSelectStylePost,
  convertToDesign: generatedApi.convertToDesignApiV1GenerationVariantsVariantIdConvertPost,
  quickGenerate: generatedApi.quickGenerateApiV1GenerationQuickGeneratePost,
  quickGeneratePhoto: generatedApi.quickGeneratePhotoApiV1GenerationQuickGeneratePhotoPost,
  searchDesigns: generatedApi.searchDesignsApiV1DesignsGet,
  getFeaturedDesigns: generatedApi.getFeaturedDesignsApiV1DesignsFeaturedGet,
  getMyDesigns: generatedApi.getMyDesignsApiV1DesignsMyDesignsGet,
  getDesignBySlug: generatedApi.getDesignBySlugApiV1DesignsSlugSlugGet,
  getDesign: generatedApi.getDesignApiV1DesignsDesignIdGet,
  updateDesign: generatedApi.updateDesignApiV1DesignsDesignIdPatch,
  deleteDesign: generatedApi.deleteDesignApiV1DesignsDesignIdDelete,
  publishDesign: generatedApi.publishDesignApiV1DesignsDesignIdPublishPost,
  unpublishDesign: generatedApi.unpublishDesignApiV1DesignsDesignIdUnpublishPost,
  likeDesign: generatedApi.likeDesignApiV1DesignsDesignIdLikePost,
  trackDesignUse: generatedApi.trackDesignUseApiV1DesignsDesignIdUsePost,
  getAvailableProductTypes: generatedApi.getAvailableProductTypesApiV1DesignsDesignIdProductTypesGet,
  generateMockup: generatedApi.generateMockupApiV1MockupsGeneratePost,
  generateBatchMockups: generatedApi.generateBatchMockupsApiV1MockupsGenerateBatchPost,
  check3dStatus: generatedApi.check3dStatusApiV1Mockups3dStatusPost,
  listAvailableTemplates: generatedApi.listAvailableTemplatesApiV1MockupsTemplatesGet,
  generateMultiviewEnhancement: generatedApi.generateMultiviewEnhancementApiV1EnhancementMultiviewPost,
  triggerAbandonedDesignRecovery: generatedApi.triggerAbandonedDesignRecoveryApiV1ScheduledTasksAbandonedDesignRecoveryPost,
  triggerAbandonedCartRecovery: generatedApi.triggerAbandonedCartRecoveryApiV1ScheduledTasksAbandonedCartRecoveryPost,
  triggerRefreshExchangeRates: generatedApi.triggerRefreshExchangeRatesApiV1ScheduledTasksRefreshExchangeRatesPost,
  triggerCheckExchangeRateValidity: generatedApi.triggerCheckExchangeRateValidityApiV1ScheduledTasksCheckExchangeRateValidityPost,
  triggerGelatoCatalogSync: generatedApi.triggerGelatoCatalogSyncApiV1ScheduledTasksGelatoCatalogSyncPost,
  triggerGelatoCatalogHealthCheck: generatedApi.triggerGelatoCatalogHealthCheckApiV1ScheduledTasksGelatoCatalogHealthCheckPost,
  root_Get: generatedApi.root__get,
  healthHealthGet: generatedApi.health_health_get,
  readinessHealthReadyGet: generatedApi.readiness_health_ready_get,
  livenessHealthLiveGet: generatedApi.liveness_health_live_get,
  databaseHealthHealthDbGet: generatedApi.database_health_health_db_get,
  healthzHealthzGet: generatedApi.healthz_healthz_get,
  readyzReadyzGet: generatedApi.readyz_readyz_get,
  metricsMetricsGet: generatedApi.metrics_metrics_get,
} as typeof generatedApi & {
  addItemToCart: typeof generatedApi.addItemToCartApiV1CartAddPost;
  getCart: typeof generatedApi.getCartApiV1CartSessionIdGet;
  clearCart: typeof generatedApi.clearCartApiV1CartSessionIdDelete;
  getCartTotal: typeof generatedApi.getCartTotalApiV1CartSessionIdTotalGet;
  updateCartItem: typeof generatedApi.updateCartItemApiV1CartSessionIdItemsItemIdPatch;
  removeCartItem: typeof generatedApi.removeCartItemApiV1CartSessionIdItemsItemIdDelete;
  removeCartItemFromCookie: typeof generatedApi.removeCartItemFromCookieApiV1CartItemsItemIdDelete;
  createChatSession: typeof generatedApi.createChatSessionApiV1ChatSessionsPost;
  chatMessageStandardized: typeof generatedApi.chatMessageStandardizedApiV1ChatSessionsSessionIdMessagePost;
  chatMessage: typeof generatedApi.chatMessageApiV1ChatMessagePost;
  getOrdersBySession: typeof generatedApi.getOrdersBySessionApiV1OrdersBySessionPost;
  updateDelivery: typeof generatedApi.updateDeliveryApiV1OrdersOrderIdDeliveryPut;
  getOrder: typeof generatedApi.getOrderApiV1OrdersOrderIdGet;
  lookupOrder: typeof generatedApi.lookupOrderApiV1OrderLookup_Post;
  getOrderTotal: typeof generatedApi.getOrderTotalApiV1OrderTotal_Get;
  getTrackingInfo: typeof generatedApi.getTrackingInfoApiV1TrackingOrderIdGet;
  getStatusTimeline: typeof generatedApi.getStatusTimelineApiV1TrackingOrderIdTimelineGet;
  updateOrderStatus: typeof generatedApi.updateOrderStatusApiV1TrackingOrderIdStatusPost;
  getTrackingByEmail: typeof generatedApi.getTrackingByEmailApiV1TrackingByEmailEmailGet;
  getTrackingByOrderNumber: typeof generatedApi.getTrackingByOrderNumberApiV1TrackingByOrderNumberOrderNumberGet;
  refreshDeliveryEstimates: typeof generatedApi.refreshDeliveryEstimatesApiV1TrackingOrderIdRefreshEstimatesPost;
  uploadPhoto: typeof generatedApi.uploadPhotoApiV1PhotosPost;
  createFromUrl: typeof generatedApi.createFromUrlApiV1PhotosFromUrlPost;
  getPhoto: typeof generatedApi.getPhotoApiV1PhotosPhotoIdGet;
  deletePhoto: typeof generatedApi.deletePhotoApiV1PhotosPhotoIdDelete;
  getPhotosBySource: typeof generatedApi.getPhotosBySourceApiV1PhotosBySourceSourceTypeSourceIdGet;
  analyzePhoto: typeof generatedApi.analyzePhotoApiV1PhotosPhotoIdAnalyzePost;
  createThumbnail: typeof generatedApi.createThumbnailApiV1PhotosPhotoIdThumbnailPost;
  updateProcessedUrl: typeof generatedApi.updateProcessedUrlApiV1PhotosPhotoIdProcessedUrlPatch;
  createSession: typeof generatedApi.createSessionApiV1GenerationSessionsPost;
  listSessions: typeof generatedApi.listSessionsApiV1GenerationSessionsGet;
  getSession: typeof generatedApi.getSessionApiV1GenerationSessionsSessionIdGet;
  buildPrompt: typeof generatedApi.buildPromptApiV1GenerationSessionsSessionIdBuildPromptPost;
  generateVariants: typeof generatedApi.generateVariantsApiV1GenerationSessionsSessionIdGeneratePost;
  selectVariant: typeof generatedApi.selectVariantApiV1GenerationVariantsVariantIdSelectPost;
  selectStyleAndGenerate: typeof generatedApi.selectStyleAndGenerateApiV1GenerationSessionsSessionIdSelectStylePost;
  convertToDesign: typeof generatedApi.convertToDesignApiV1GenerationVariantsVariantIdConvertPost;
  quickGenerate: typeof generatedApi.quickGenerateApiV1GenerationQuickGeneratePost;
  quickGeneratePhoto: typeof generatedApi.quickGeneratePhotoApiV1GenerationQuickGeneratePhotoPost;
  searchDesigns: typeof generatedApi.searchDesignsApiV1DesignsGet;
  getFeaturedDesigns: typeof generatedApi.getFeaturedDesignsApiV1DesignsFeaturedGet;
  getMyDesigns: typeof generatedApi.getMyDesignsApiV1DesignsMyDesignsGet;
  getDesignBySlug: typeof generatedApi.getDesignBySlugApiV1DesignsSlugSlugGet;
  getDesign: typeof generatedApi.getDesignApiV1DesignsDesignIdGet;
  updateDesign: typeof generatedApi.updateDesignApiV1DesignsDesignIdPatch;
  deleteDesign: typeof generatedApi.deleteDesignApiV1DesignsDesignIdDelete;
  publishDesign: typeof generatedApi.publishDesignApiV1DesignsDesignIdPublishPost;
  unpublishDesign: typeof generatedApi.unpublishDesignApiV1DesignsDesignIdUnpublishPost;
  likeDesign: typeof generatedApi.likeDesignApiV1DesignsDesignIdLikePost;
  trackDesignUse: typeof generatedApi.trackDesignUseApiV1DesignsDesignIdUsePost;
  getAvailableProductTypes: typeof generatedApi.getAvailableProductTypesApiV1DesignsDesignIdProductTypesGet;
  generateMockup: typeof generatedApi.generateMockupApiV1MockupsGeneratePost;
  generateBatchMockups: typeof generatedApi.generateBatchMockupsApiV1MockupsGenerateBatchPost;
  check3dStatus: typeof generatedApi.check3dStatusApiV1Mockups3dStatusPost;
  listAvailableTemplates: typeof generatedApi.listAvailableTemplatesApiV1MockupsTemplatesGet;
  generateMultiviewEnhancement: typeof generatedApi.generateMultiviewEnhancementApiV1EnhancementMultiviewPost;
  triggerAbandonedDesignRecovery: typeof generatedApi.triggerAbandonedDesignRecoveryApiV1ScheduledTasksAbandonedDesignRecoveryPost;
  triggerAbandonedCartRecovery: typeof generatedApi.triggerAbandonedCartRecoveryApiV1ScheduledTasksAbandonedCartRecoveryPost;
  triggerRefreshExchangeRates: typeof generatedApi.triggerRefreshExchangeRatesApiV1ScheduledTasksRefreshExchangeRatesPost;
  triggerCheckExchangeRateValidity: typeof generatedApi.triggerCheckExchangeRateValidityApiV1ScheduledTasksCheckExchangeRateValidityPost;
  triggerGelatoCatalogSync: typeof generatedApi.triggerGelatoCatalogSyncApiV1ScheduledTasksGelatoCatalogSyncPost;
  triggerGelatoCatalogHealthCheck: typeof generatedApi.triggerGelatoCatalogHealthCheckApiV1ScheduledTasksGelatoCatalogHealthCheckPost;
  root_Get: typeof generatedApi.root__get;
  healthHealthGet: typeof generatedApi.health_health_get;
  readinessHealthReadyGet: typeof generatedApi.readiness_health_ready_get;
  livenessHealthLiveGet: typeof generatedApi.liveness_health_live_get;
  databaseHealthHealthDbGet: typeof generatedApi.database_health_health_db_get;
  healthzHealthzGet: typeof generatedApi.healthz_healthz_get;
  readyzReadyzGet: typeof generatedApi.readyz_readyz_get;
  metricsMetricsGet: typeof generatedApi.metrics_metrics_get;
};
// Convenience aliases for commonly used hooks
// These match the expected names in the frontend codebase
import {
  useAddItemToCartApiV1CartAddPost,
  useAnalyzePhotoApiV1PhotosPhotoIdAnalyzePost,
  useBuildPromptApiV1GenerationSessionsSessionIdBuildPromptPost,
  useChatMessageApiV1ChatMessagePost,
  useChatMessageStandardizedApiV1ChatSessionsSessionIdMessagePost,
  useCheck3dStatusApiV1Mockups3dStatusPost,
  useClearCartApiV1CartSessionIdDelete,
  useConvertToDesignApiV1GenerationVariantsVariantIdConvertPost,
  useCreateChatSessionApiV1ChatSessionsPost,
  useCreateFromUrlApiV1PhotosFromUrlPost,
  useCreateSessionApiV1GenerationSessionsPost,
  useCreateThumbnailApiV1PhotosPhotoIdThumbnailPost,
  useDatabase_health_health_db_get,
  useDeleteDesignApiV1DesignsDesignIdDelete,
  useDeletePhotoApiV1PhotosPhotoIdDelete,
  useGenerateBatchMockupsApiV1MockupsGenerateBatchPost,
  useGenerateMockupApiV1MockupsGeneratePost,
  useGenerateMultiviewEnhancementApiV1EnhancementMultiviewPost,
  useGenerateVariantsApiV1GenerationSessionsSessionIdGeneratePost,
  useGetAvailableProductTypesApiV1DesignsDesignIdProductTypesGet,
  useGetCartApiV1CartSessionIdGet,
  useGetCartTotalApiV1CartSessionIdTotalGet,
  useGetDesignApiV1DesignsDesignIdGet,
  useGetDesignBySlugApiV1DesignsSlugSlugGet,
  useGetFeaturedDesignsApiV1DesignsFeaturedGet,
  useGetMyDesignsApiV1DesignsMyDesignsGet,
  useGetOrderApiV1OrdersOrderIdGet,
  useGetOrdersBySessionApiV1OrdersBySessionPost,
  useGetOrderTotalApiV1OrderTotal_Get,
  useGetPhotoApiV1PhotosPhotoIdGet,
  useGetPhotosBySourceApiV1PhotosBySourceSourceTypeSourceIdGet,
  useGetSessionApiV1GenerationSessionsSessionIdGet,
  useGetStatusTimelineApiV1TrackingOrderIdTimelineGet,
  useGetTrackingByEmailApiV1TrackingByEmailEmailGet,
  useGetTrackingByOrderNumberApiV1TrackingByOrderNumberOrderNumberGet,
  useGetTrackingInfoApiV1TrackingOrderIdGet,
  useHealth_health_get,
  useHealthz_healthz_get,
  useLikeDesignApiV1DesignsDesignIdLikePost,
  useListAvailableTemplatesApiV1MockupsTemplatesGet,
  useListSessionsApiV1GenerationSessionsGet,
  useLiveness_health_live_get,
  useLookupOrderApiV1OrderLookup_Post,
  useMetrics_metrics_get,
  usePublishDesignApiV1DesignsDesignIdPublishPost,
  useQuickGenerateApiV1GenerationQuickGeneratePost,
  useQuickGeneratePhotoApiV1GenerationQuickGeneratePhotoPost,
  useReadiness_health_ready_get,
  useReadyz_readyz_get,
  useRefreshDeliveryEstimatesApiV1TrackingOrderIdRefreshEstimatesPost,
  useRemoveCartItemApiV1CartSessionIdItemsItemIdDelete,
  useRemoveCartItemFromCookieApiV1CartItemsItemIdDelete,
  useRoot__get,
  useSearchDesignsApiV1DesignsGet,
  useSelectStyleAndGenerateApiV1GenerationSessionsSessionIdSelectStylePost,
  useSelectVariantApiV1GenerationVariantsVariantIdSelectPost,
  useTrackDesignUseApiV1DesignsDesignIdUsePost,
  useTriggerAbandonedCartRecoveryApiV1ScheduledTasksAbandonedCartRecoveryPost,
  useTriggerAbandonedDesignRecoveryApiV1ScheduledTasksAbandonedDesignRecoveryPost,
  useTriggerCheckExchangeRateValidityApiV1ScheduledTasksCheckExchangeRateValidityPost,
  useTriggerGelatoCatalogHealthCheckApiV1ScheduledTasksGelatoCatalogHealthCheckPost,
  useTriggerGelatoCatalogSyncApiV1ScheduledTasksGelatoCatalogSyncPost,
  useTriggerRefreshExchangeRatesApiV1ScheduledTasksRefreshExchangeRatesPost,
  useUnpublishDesignApiV1DesignsDesignIdUnpublishPost,
  useUpdateCartItemApiV1CartSessionIdItemsItemIdPatch,
  useUpdateDeliveryApiV1OrdersOrderIdDeliveryPut,
  useUpdateDesignApiV1DesignsDesignIdPatch,
  useUpdateOrderStatusApiV1TrackingOrderIdStatusPost,
  useUpdateProcessedUrlApiV1PhotosPhotoIdProcessedUrlPatch,
  useUploadPhotoApiV1PhotosPost
} from './generated-hooks';

/**
 * Convenience aliases for commonly used hooks
 * These match the expected names in the frontend codebase
 */
export {
  useAddItemToCartApiV1CartAddPost as useAddItemToCart,
  useAnalyzePhotoApiV1PhotosPhotoIdAnalyzePost as useAnalyzePhoto,
  useBuildPromptApiV1GenerationSessionsSessionIdBuildPromptPost as useBuildPrompt,
  useChatMessageApiV1ChatMessagePost as useChatMessage,
  useChatMessageStandardizedApiV1ChatSessionsSessionIdMessagePost as useChatMessageStandardized,
  useCheck3dStatusApiV1Mockups3dStatusPost as useCheck3dStatus,
  useClearCartApiV1CartSessionIdDelete as useClearCart,
  useConvertToDesignApiV1GenerationVariantsVariantIdConvertPost as useConvertToDesign,
  useCreateChatSessionApiV1ChatSessionsPost as useCreateChatSession,
  useCreateFromUrlApiV1PhotosFromUrlPost as useCreateFromUrl,
  useCreateSessionApiV1GenerationSessionsPost as useCreateSession,
  useCreateThumbnailApiV1PhotosPhotoIdThumbnailPost as useCreateThumbnail,
  useDatabase_health_health_db_get as useDatabaseHealthHealthDbGet,
  useDeleteDesignApiV1DesignsDesignIdDelete as useDeleteDesign,
  useDeletePhotoApiV1PhotosPhotoIdDelete as useDeletePhoto,
  useGenerateBatchMockupsApiV1MockupsGenerateBatchPost as useGenerateBatchMockups,
  useGenerateMockupApiV1MockupsGeneratePost as useGenerateMockup,
  useGenerateMultiviewEnhancementApiV1EnhancementMultiviewPost as useGenerateMultiviewEnhancement,
  useGenerateVariantsApiV1GenerationSessionsSessionIdGeneratePost as useGenerateVariants,
  useGetAvailableProductTypesApiV1DesignsDesignIdProductTypesGet as useGetAvailableProductTypes,
  useGetCartApiV1CartSessionIdGet as useGetCart,
  useGetCartTotalApiV1CartSessionIdTotalGet as useGetCartTotal,
  useGetDesignApiV1DesignsDesignIdGet as useGetDesign,
  useGetDesignBySlugApiV1DesignsSlugSlugGet as useGetDesignBySlug,
  useGetFeaturedDesignsApiV1DesignsFeaturedGet as useGetFeaturedDesigns,
  useGetMyDesignsApiV1DesignsMyDesignsGet as useGetMyDesigns,
  useGetOrderApiV1OrdersOrderIdGet as useGetOrder,
  useGetOrdersBySessionApiV1OrdersBySessionPost as useGetOrdersBySession,
  useGetOrderTotalApiV1OrderTotal_Get as useGetOrderTotal,
  useGetPhotoApiV1PhotosPhotoIdGet as useGetPhoto,
  useGetPhotosBySourceApiV1PhotosBySourceSourceTypeSourceIdGet as useGetPhotosBySource,
  useGetSessionApiV1GenerationSessionsSessionIdGet as useGetSession,
  useGetStatusTimelineApiV1TrackingOrderIdTimelineGet as useGetStatusTimeline,
  useGetTrackingByEmailApiV1TrackingByEmailEmailGet as useGetTrackingByEmail,
  useGetTrackingByOrderNumberApiV1TrackingByOrderNumberOrderNumberGet as useGetTrackingByOrderNumber,
  useGetTrackingInfoApiV1TrackingOrderIdGet as useGetTrackingInfo,
  useHealth_health_get as useHealthHealthGet,
  useHealthz_healthz_get as useHealthzHealthzGet,
  useLikeDesignApiV1DesignsDesignIdLikePost as useLikeDesign,
  useListAvailableTemplatesApiV1MockupsTemplatesGet as useListAvailableTemplates,
  useListSessionsApiV1GenerationSessionsGet as useListSessions,
  useLiveness_health_live_get as useLivenessHealthLiveGet,
  useLookupOrderApiV1OrderLookup_Post as useLookupOrder,
  useMetrics_metrics_get as useMetricsMetricsGet,
  usePublishDesignApiV1DesignsDesignIdPublishPost as usePublishDesign,
  useQuickGenerateApiV1GenerationQuickGeneratePost as useQuickGenerate,
  useQuickGeneratePhotoApiV1GenerationQuickGeneratePhotoPost as useQuickGeneratePhoto,
  useReadiness_health_ready_get as useReadinessHealthReadyGet,
  useReadyz_readyz_get as useReadyzReadyzGet,
  useRefreshDeliveryEstimatesApiV1TrackingOrderIdRefreshEstimatesPost as useRefreshDeliveryEstimates,
  useRemoveCartItemApiV1CartSessionIdItemsItemIdDelete as useRemoveCartItem,
  useRemoveCartItemFromCookieApiV1CartItemsItemIdDelete as useRemoveCartItemFromCookie,
  useRoot__get as useRoot_Get,
  useSearchDesignsApiV1DesignsGet as useSearchDesigns,
  useSelectStyleAndGenerateApiV1GenerationSessionsSessionIdSelectStylePost as useSelectStyleAndGenerate,
  useSelectVariantApiV1GenerationVariantsVariantIdSelectPost as useSelectVariant,
  useTrackDesignUseApiV1DesignsDesignIdUsePost as useTrackDesignUse,
  useTriggerAbandonedCartRecoveryApiV1ScheduledTasksAbandonedCartRecoveryPost as useTriggerAbandonedCartRecovery,
  useTriggerAbandonedDesignRecoveryApiV1ScheduledTasksAbandonedDesignRecoveryPost as useTriggerAbandonedDesignRecovery,
  useTriggerCheckExchangeRateValidityApiV1ScheduledTasksCheckExchangeRateValidityPost as useTriggerCheckExchangeRateValidity,
  useTriggerGelatoCatalogHealthCheckApiV1ScheduledTasksGelatoCatalogHealthCheckPost as useTriggerGelatoCatalogHealthCheck,
  useTriggerGelatoCatalogSyncApiV1ScheduledTasksGelatoCatalogSyncPost as useTriggerGelatoCatalogSync,
  useTriggerRefreshExchangeRatesApiV1ScheduledTasksRefreshExchangeRatesPost as useTriggerRefreshExchangeRates,
  useUnpublishDesignApiV1DesignsDesignIdUnpublishPost as useUnpublishDesign,
  useUpdateCartItemApiV1CartSessionIdItemsItemIdPatch as useUpdateCartItem,
  useUpdateDeliveryApiV1OrdersOrderIdDeliveryPut as useUpdateDelivery,
  useUpdateDesignApiV1DesignsDesignIdPatch as useUpdateDesign,
  useUpdateOrderStatusApiV1TrackingOrderIdStatusPost as useUpdateOrderStatus,
  useUpdateProcessedUrlApiV1PhotosPhotoIdProcessedUrlPatch as useUpdateProcessedUrl,
  useUploadPhotoApiV1PhotosPost as useUploadPhoto
};

